import React from "react";
import { useTranslation } from "react-i18next";
import { Minus, Plus, CheckCircle2 } from "lucide-react";
import { PARTIAL_TASKS } from "@/lib/api";

export const hasPartialSelection = (tasks, addons) =>
  Object.values(tasks || {}).some((q) => Number(q) > 0) || (addons || []).length > 0;

export const partialTasksPayload = (tasks) =>
  Object.fromEntries(Object.entries(tasks || {}).filter(([, q]) => Number(q) > 0).map(([k, q]) => [k, Number(q)]));

export default function PartialTasksPicker({ value = {}, onChange, testidPrefix = "partial", compact = false }) {
  const { t } = useTranslation();
  const setQty = (key, q) => onChange({ ...value, [key]: Math.max(0, Math.min(10, q)) });
  return (
    <div className={`grid gap-2 ${compact ? "grid-cols-2 sm:grid-cols-3" : "sm:grid-cols-2"}`} data-testid={`${testidPrefix}-tasks`}>
      {PARTIAL_TASKS.map((task) => {
        const qty = Number(value[task.key] || 0);
        const on = qty > 0;
        return (
          <div key={task.key} data-testid={`${testidPrefix}-task-${task.key}`}
            className={`rounded-lg px-3 py-2.5 ring-1 transition-[background-color,box-shadow] flex items-center justify-between gap-2 ${on ? "bg-[#E8F5E0] ring-[#5BA83F]" : "bg-white ring-slate-200 hover:ring-slate-300"}`}>
            <label className="flex items-center gap-2.5 cursor-pointer flex-1 min-w-0">
              <input type="checkbox" checked={on} onChange={(e) => setQty(task.key, e.target.checked ? 1 : 0)}
                className="w-4 h-4 accent-[#5BA83F]" data-testid={`${testidPrefix}-task-${task.key}-checkbox`} />
              <span className="min-w-0">
                <span className={`block font-semibold text-[#0F172A] ${compact ? "text-xs" : "text-sm"}`}>{t(`partial.tasks.${task.key}`)}</span>
                <span className="block text-[11px] text-slate-500">{task.minutes} min{task.multi ? ` ${t("partial.each")}` : ""}</span>
              </span>
            </label>
            {on && task.multi ? (
              <div className="flex items-center gap-1 shrink-0">
                <button type="button" onClick={() => setQty(task.key, qty - 1)} className="w-6 h-6 rounded-full bg-white ring-1 ring-slate-300 flex items-center justify-center" data-testid={`${testidPrefix}-task-${task.key}-minus`} aria-label="decrease"><Minus className="w-3 h-3" /></button>
                <span className="w-5 text-center text-sm font-bold" data-testid={`${testidPrefix}-task-${task.key}-qty`}>{qty}</span>
                <button type="button" onClick={() => setQty(task.key, qty + 1)} className="w-6 h-6 rounded-full bg-white ring-1 ring-slate-300 flex items-center justify-center" data-testid={`${testidPrefix}-task-${task.key}-plus`} aria-label="increase"><Plus className="w-3 h-3" /></button>
              </div>
            ) : on ? <CheckCircle2 className="w-4 h-4 text-[#5BA83F] shrink-0" /> : null}
          </div>
        );
      })}
    </div>
  );
}
